import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titleCapitalize',
})
export class TitleCapitalizePipe implements PipeTransform {
  transform(value: string): any {
    return this.capitalize(value);
  }

  capitalize(word): string {
    return word
      .replace('-', ' ')
      .split('')
      .map((letter, index) => (index ? letter.toLowerCase() : letter.toUpperCase()))
      .join('');
  }
}
